import Logo from './Logo';

const cols = [
  {
    h: 'Product',
    items: [
      { label: 'Auth', accent: true },
      { label: 'Store' },
      { label: 'Comms' },
      { label: 'Realtime' },
      { label: 'Pricing' },
    ],
  },
  {
    h: 'Resources',
    items: [
      { label: 'Docs' },
      { label: 'Quickstart' },
      { label: 'Examples' },
      { label: 'Changelog' },
      { label: 'Status', live: true },
    ],
  },
  {
    h: 'Company',
    items: [
      { label: 'About' },
      { label: 'Manifesto' },
      { label: 'Customers' },
      { label: 'Careers', hiring: true },
      { label: 'Contact' },
    ],
  },
  {
    h: 'Legal',
    items: [
      { label: 'Terms' },
      { label: 'Privacy' },
      { label: 'Security' },
      { label: 'DPA' },
      { label: 'SOC 2' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-border bg-slate50">
      <div className="mx-auto w-full max-w-[1440px] px-6 lg:px-8 py-14">
        <div className="grid grid-cols-12 gap-8">
          {/* brand */}
          <div className="col-span-12 md:col-span-4">
            <Logo />
            <p className="mt-4 max-w-[280px] text-[14px] text-body">
              The base layer for modern apps. Auth, DB, comms, realtime — bundled.
            </p>
            <div className="mt-6 flex gap-2">
              {['X', 'GH', 'DC'].map(s => (
                <a
                  key={s}
                  href="#"
                  aria-label={s}
                  className="grid size-8 place-items-center rounded-lg border border-border bg-surface text-[12px] font-semibold text-body transition-colors hover:border-borderStrong hover:text-ink"
                >
                  {s}
                </a>
              ))}
            </div>
          </div>

          {/* link cols */}
          <div className="col-span-12 grid grid-cols-2 gap-8 md:col-span-8 md:grid-cols-4">
            {cols.map(c => (
              <div key={c.h}>
                <p className="text-[11px] font-bold uppercase tracking-wider text-muted">{c.h}</p>
                <ul className="mt-4 space-y-2.5">
                  {c.items.map(it => (
                    <li key={it.label} className="flex items-center gap-2">
                      <a
                        href="#"
                        className={`text-[14px] transition-colors ${
                          'accent' in it && it.accent
                            ? 'font-semibold text-violet hover:text-violetMid'
                            : 'text-body hover:text-ink'
                        }`}
                      >
                        {it.label}
                      </a>
                      {'live' in it && it.live && (
                        <span className="size-1.5 rounded-full bg-ok" aria-label="live" />
                      )}
                      {'hiring' in it && it.hiring && (
                        <span className="rounded-full border border-pink/40 bg-pinkSoft px-1.5 py-px text-[9px] font-bold text-pinkMid">
                          we're hiring
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* bottom row */}
        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-border pt-6 md:flex-row md:items-center">
          <p className="text-[12px] text-muted">© 2026 Pryma. All primitives reserved.</p>
          <p className="font-mono text-[11px] text-muted">made with prism · pryma.dev</p>
        </div>
      </div>
    </footer>
  );
}
